"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTripTrackingUrl = buildTripTrackingUrl;
function buildTripTrackingUrl(params) {
    const { siteBaseUrl, orderId, jwtToken, trackingTag, locale } = params;
    const jwtTagParam = `t=${jwtToken}`;
    if (!trackingTag || !trackingTag.length) {
        return `${siteBaseUrl}/r/ttp/${orderId}?${jwtTagParam}`;
    }
    const trackingTagParam = `trackingTag=${trackingTag}`;
    return `${siteBaseUrl}${locale ? `/${locale}` : ""}/r/ttp/${orderId}?${trackingTagParam}&${jwtTagParam}`;
}
//# sourceMappingURL=build-trip-tracking-url.js.map